export default __webpack_public_path__ + "static/media/image.rani-creative-solutions-pvt-ltd.77e4da12.png";